export enum FetchMethods {
    POST = "POST",
    GET = "GET",
    PATCH = "PATCH",
    DELETE = "DELETE"
}